import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

export const getQuestionsList = createAsyncThunk(
  'getQuestionsList',
  async (params, { rejectWithValue }) => {
    try {
      const token = params.token;
      const sId = params?.sId;

      const urls = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_PREFIX_URL}${sId}/question/list/`;

      const headers = { Authorization: `Bearer ${token}` };

      const response = await axios.get(urls, { headers });
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const questionListSlice = createSlice({
  name: 'questionList',
  initialState,
  reducers: {
    clearData(state) {
      state.data = [];
      state.error = '';
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getQuestionsList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getQuestionsList.fulfilled, (state, action) => {
      // console.log('Updated data:', action.payload);
      state.loading = false;
      state.data = action.payload;
      state.error = '';
    });
    builder.addCase(getQuestionsList.rejected, (state, action) => {
      state.loading = false;
      state.data = [];
      state.error = action.error.message;
    });
  },
});
export const { clearData, setLoading } = questionListSlice.actions;
export default questionListSlice.reducer;
